import React from 'react'

export default () =>
  <div className="text-center">
    <i className="fas fa-spinner-third fa-spin my-3" />
  </div>
